/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Hangar,
  SchemaValidationErrorResponse,
  StandardError,
  VehicleExportsList,
  WishlistItemsList,
  WishlistParams
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Clear your Wishlist
 */
export const destroyWishlist = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/wishlist`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyWishlistMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWishlist>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyWishlist>>, TError,void, TContext> => {

const mutationKey = ['destroyWishlist'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyWishlist>>, void> = () => {


          return  destroyWishlist()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyWishlistMutationResult = NonNullable<Awaited<ReturnType<typeof destroyWishlist>>>

    export type DestroyWishlistMutationError = ErrorType<StandardError>


    /**
 * @summary Clear your Wishlist
 */
export const useDestroyWishlist = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyWishlist>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyWishlist>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyWishlistMutationOptions(options), queryClient);
    }
    /**
 * @summary Your Wishlist
 */
export const wishlist = (
    params?: MaybeRefOrGetter<WishlistParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Hangar>(
      {url: `/wishlist`, method: 'GET',
        params, signal
    },
      );
    }




export const getWishlistQueryKey = (params?: MaybeRefOrGetter<WishlistParams>,) => {
    return [
    'wishlist', ...(params ? [params] : [])
    ] as const;
    }


export const getWishlistQueryOptions = <TData = Awaited<ReturnType<typeof wishlist>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<WishlistParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishlist>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getWishlistQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wishlist>>> = ({ signal }) => wishlist(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wishlist>>, TError, TData>
}

export type WishlistQueryResult = NonNullable<Awaited<ReturnType<typeof wishlist>>>
export type WishlistQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Your Wishlist
 */

export function useWishlist<TData = Awaited<ReturnType<typeof wishlist>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<WishlistParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishlist>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWishlistQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Export your Wishlist
 */
export const exportWishlist = (

 signal?: AbortSignal
) => {


      return axiosClient<VehicleExportsList>(
      {url: `/wishlist/export`, method: 'GET', signal
    },
      );
    }




export const getExportWishlistQueryKey = () => {
    return [
    'wishlist','export'
    ] as const;
    }


export const getExportWishlistQueryOptions = <TData = Awaited<ReturnType<typeof exportWishlist>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportWishlist>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getExportWishlistQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportWishlist>>> = ({ signal }) => exportWishlist(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportWishlist>>, TError, TData>
}

export type ExportWishlistQueryResult = NonNullable<Awaited<ReturnType<typeof exportWishlist>>>
export type ExportWishlistQueryError = ErrorType<StandardError>


/**
 * @summary Export your Wishlist
 */

export function useExportWishlist<TData = Awaited<ReturnType<typeof exportWishlist>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportWishlist>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportWishlistQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Your Wishlist items
 */
export const wishlistItems = (

 signal?: AbortSignal
) => {


      return axiosClient<WishlistItemsList>(
      {url: `/wishlist/items`, method: 'GET', signal
    },
      );
    }




export const getWishlistItemsQueryKey = () => {
    return [
    'wishlist','items'
    ] as const;
    }


export const getWishlistItemsQueryOptions = <TData = Awaited<ReturnType<typeof wishlistItems>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishlistItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getWishlistItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wishlistItems>>> = ({ signal }) => wishlistItems(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wishlistItems>>, TError, TData>
}

export type WishlistItemsQueryResult = NonNullable<Awaited<ReturnType<typeof wishlistItems>>>
export type WishlistItemsQueryError = ErrorType<StandardError>


/**
 * @summary Your Wishlist items
 */

export function useWishlistItems<TData = Awaited<ReturnType<typeof wishlistItems>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishlistItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWishlistItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






